import React, { useEffect, useState } from "react";
import { CircularAvatar, DropDown } from "../../../commons";
import { components } from "react-select";
import Select from "react-select";
import { InputDetailsErrorType } from "..";
type AppProps = {
  finalUserList: any;
  assignedDropDownValue: any;
  finalBranchDataList: any;
  currencyData: any;
  limit: number;
  managerLimit: number;
  clientGroupLimit: number;
  partnerLimit: number;
  text: string;
  branchText: string;
  clientGroupText: string;
  currencyText: string;
  userFetching: boolean;
  branchFetching: boolean;
  finalManagerList: any;
  finalPartnerList: any;
  managerFetching: boolean;
  managerText: string;
  partnerText: string;
  finalClientGroupDataList: any;
  setClientGroupOffset: React.Dispatch<React.SetStateAction<number>>;
  setManagerOffset: React.Dispatch<React.SetStateAction<number>>;
  setManagerText: React.Dispatch<React.SetStateAction<string>>;
  setClientGroupText: React.Dispatch<React.SetStateAction<string>>;
  setPartnerOffset: React.Dispatch<React.SetStateAction<number>>;
  setoffset: React.Dispatch<React.SetStateAction<number>>;
  setText: (e: string) => void;
  partnerFetching: boolean;
  setPartnerText: React.Dispatch<React.SetStateAction<string>>;
  setCurrencyText: React.Dispatch<React.SetStateAction<string>>;
  setBranchText: React.Dispatch<React.SetStateAction<string>>;
  handleAssignedDropdownChange: (data: any, name: string) => void;
  handleBranceDetailsChange: (data: any) => void;
  handleCurrencyDetailsChange: (data: any) => void;
  handleClientGroupDetailsChange: (data: any) => void;
  isDisabled?: boolean;
  isEdit?: boolean;
  inputDetailsError: InputDetailsErrorType;
};
const AssignedTo = ({
  finalUserList,
  handleAssignedDropdownChange,
  assignedDropDownValue,
  finalBranchDataList,
  handleBranceDetailsChange,
  handleCurrencyDetailsChange,
  handleClientGroupDetailsChange,
  setoffset,
  finalClientGroupDataList,
  clientGroupText,
  setClientGroupText,
  clientGroupLimit,
  setClientGroupOffset,
  limit,
  managerText,
  partnerText,
  finalManagerList,
  finalPartnerList,
  managerFetching,
  setManagerOffset,
  setManagerText,
  partnerFetching,
  setPartnerOffset,
  setPartnerText,
  currencyData,
  setText,
  setCurrencyText,
  setBranchText,
  userFetching,
  text,
  branchText,
  branchFetching,
  currencyText,
  managerLimit,
  partnerLimit,
  isDisabled,
  inputDetailsError,
  isEdit,
}: AppProps) => {
  const [seniorManagerText, setSeniorManagerText] = useState("");
  const [accountText, setAccounttText] = useState("");
  const [taxText, setTaxText] = useState("");
  const [auditText, setAuditText] = useState("");
  const [hrText, setHrText] = useState("");
  const userIsLoading = userFetching && text?.length ? true : false;
  const branchIsLoading = branchFetching && branchText?.length ? true : false;
  const currencyIsLoading =
    branchFetching && currencyText?.length ? true : false;
  const clientGroupIsLoading =
    branchFetching && clientGroupText?.length ? true : false;
  const Option = (props: any) => {
    const { data } = props;
    return (
      <components.Option {...props}>
        {data?.value !== null ? (
          <div
            className="d-flex justify-content-sm-start"
            style={{ gap: "10px" }}
          >
            <CircularAvatar
              name={data?.label.split("%")[0]}
              image={data?.image && data?.image}
            />
            <div style={{ marginTop: "-3px" }}>
              <span style={{ fontWeight: "500", fontSize: "16px" }}>
                {data?.label.split("%")[0]}
              </span>
              <br></br>
              <span style={{ color: "#6e7491" }}>
                {data?.label.split("%")[1]}
              </span>
            </div>
          </div>
        ) : (
          <div style={{ fontWeight: "500", fontSize: "16px" }}>
            {data?.label}
          </div>
        )}
      </components.Option>
    );
  };
  const dropDownStyle = {
    option: (baseStyles: any, state: any) => ({
      ...baseStyles,
      width: "300px",
    }),
    control: (provided: any, state: any) => ({
      ...provided,
      width: "77%",
    }),
    container: (provided: any) => ({
      ...provided,
      width: 320,
      position: "absolute",
    }),
  };

  const checkBottom = (e: any) => {
    setoffset((prv: any) => prv + limit);
  };
  const checkClientGroupBottom = (e: any) => {
    setClientGroupOffset((prv: any) => prv + clientGroupLimit);
  };

  const checkManagerBottom = (e: any) => {
    setManagerOffset((prv: any) => prv + managerLimit);
  };

  const checkPartnerBottom = (e: any) => {
    setPartnerOffset((prv: any) => prv + partnerLimit);
  };

  return (
    <>
      <div className="row">
        <div className="col-md-3">
          <label htmlFor="">Partner</label>
          <Select
            styles={dropDownStyle}
            options={finalPartnerList}
            value={assignedDropDownValue?.partner}
            components={{ Option }}
            onChange={(e) => handleAssignedDropdownChange(e, "partner")}
            isSearchable={true}
            isLoading={partnerFetching && partnerText?.length > 0}
            onMenuClose={() => {
              setPartnerOffset(0);
            }}
            onMenuScrollToBottom={(e: any) => checkPartnerBottom(e)}
            isDisabled={isDisabled}
            onInputChange={(e) => {
              setPartnerText(e);
            }}
          />
        </div>
        <div className="col-md-3">
          <label htmlFor="">Senior Manager</label>
          <Select
            styles={dropDownStyle}
            options={finalManagerList}
            value={assignedDropDownValue?.seniorManager}
            components={{ Option }}
            onChange={(e) => handleAssignedDropdownChange(e, "seniorManager")}
            isSearchable={true}
            isDisabled={isDisabled}
            isLoading={managerFetching && seniorManagerText?.length > 0}
            onMenuClose={() => setManagerOffset(0)}
            onMenuScrollToBottom={(e: any) => checkManagerBottom(e)}
            onInputChange={(e) => {
              setManagerText(e);
              setSeniorManagerText(e);
            }}
          />
        </div>
        <div className="col-md-3">
          <label htmlFor="">Manager</label>
          <Select
            styles={dropDownStyle}
            options={finalManagerList}
            value={assignedDropDownValue?.manager}
            components={{ Option }}
            onChange={(e) => handleAssignedDropdownChange(e, "manager")}
            isSearchable={true}
            isLoading={managerFetching && managerText?.length > 0}
            onMenuClose={() => setManagerOffset(0)}
            onMenuScrollToBottom={(e: any) => checkManagerBottom(e)}
            isDisabled={isDisabled}
            onInputChange={(e) => {
              setManagerText(e);
            }}
          />
        </div>
        <div className="col-md-3">
          <label htmlFor="">Branch</label>
          <Select
            options={finalBranchDataList}
            value={assignedDropDownValue?.branch}
            onChange={handleBranceDetailsChange}
            isSearchable={true}
            isLoading={branchIsLoading}
            onMenuClose={() => setoffset(0)}
            onMenuScrollToBottom={(e: any) => checkBottom(e)}
            onInputChange={(e) => {
              setBranchText(e);
            }}
            isDisabled={isDisabled}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-3 mt-3">
          <label htmlFor="">Accounting In-Charge</label>
          <Select
            styles={dropDownStyle}
            options={
              finalUserList?.length
                ? [
                    { value: null, label: "Select..." },
                    ...finalUserList,
                  ]
                : finalUserList
            }
            isLoading={userIsLoading && accountText?.length > 0}
            value={assignedDropDownValue?.accountingInCharge}
            components={{ Option }}
            onChange={(e) =>
              handleAssignedDropdownChange(e, "accountingInCharge")
            }
            isSearchable={true}
            onMenuScrollToBottom={(e: any) => checkBottom(e)}
            isDisabled={isDisabled}
            onInputChange={(e) => {
              setText(e);
              setAccounttText(e);
            }}
          />
        </div>
        <div className="col-md-3 mt-3">
          <label htmlFor="">Tax In-Charge</label>
          <Select
            styles={dropDownStyle}
            options={finalUserList}
            isLoading={userIsLoading && taxText?.length > 0}
            value={assignedDropDownValue?.taxInCharge}
            components={{ Option }}
            onMenuClose={() => setoffset(0)}
            onChange={(e) => handleAssignedDropdownChange(e, "taxInCharge")}
            isSearchable={true}
            onMenuScrollToBottom={(e: any) => checkBottom(e)}
            isDisabled={isDisabled}
            onInputChange={(e) => {
              setText(e);
              setTaxText(e);
            }}
          />
        </div>
        <div className="col-md-3 mt-3">
          <label htmlFor="">Audit In-Charge</label>
          <Select
            styles={dropDownStyle}
            options={finalUserList}
            isLoading={userIsLoading && auditText?.length > 0}
            value={assignedDropDownValue?.auditInCharge}
            components={{ Option }}
            onMenuClose={() => setoffset(0)}
            onChange={(e) => handleAssignedDropdownChange(e, "auditInCharge")}
            isSearchable={true}
            onMenuScrollToBottom={(e: any) => checkBottom(e)}
            onInputChange={(e) => {
              setText(e);
              setAuditText(e);
            }}
            isDisabled={isDisabled}
          />
        </div>
        <div className="col-md-3 mt-3">
          <label htmlFor="">
            Currency<span className="color-red">*</span>
          </label>
          <Select
            options={currencyData}
            value={assignedDropDownValue?.currency}
            className={`${
              inputDetailsError?.currencyError ? "error-border rounded" : ""
            }`}
            onChange={handleCurrencyDetailsChange}
            isSearchable={true}
            isLoading={currencyIsLoading}
            onMenuClose={() => setoffset(0)}
            onMenuScrollToBottom={(e: any) => checkBottom(e)}
            onInputChange={(e) => {
              setCurrencyText(e);
            }}
            isDisabled={isDisabled || isEdit}
          />
          {!!inputDetailsError?.currencyError && (
            <small className="text-danger">
              {inputDetailsError?.currencyError}
            </small>
          )}
        </div>
      </div>
      <div className="row mt-1 mb-5">
        <div className="col-md-3 mt-3">
          <label htmlFor="">HR In-Charge</label>
          <Select
            styles={dropDownStyle}
            options={finalUserList}
            value={assignedDropDownValue?.hrInCharge}
            components={{ Option }}
            isLoading={userIsLoading && hrText?.length > 0}
            onMenuClose={() => setoffset(0)}
            onChange={(e) => handleAssignedDropdownChange(e, "hrInCharge")}
            isSearchable={true}
            onMenuScrollToBottom={(e: any) => checkBottom(e)}
            onInputChange={(e) => {
              setText(e);
              setHrText(e);
            }}
            isDisabled={isDisabled}
          />
        </div>
        <div className="col-md-3 mt-3">
          <label htmlFor="">Client Group</label>
          <Select
            options={
              finalClientGroupDataList?.length
                ? [
                    { value: null, label: "Select..." },
                    ...finalClientGroupDataList,
                  ]
                : finalClientGroupDataList
            }
            value={assignedDropDownValue?.clientGroup}
            onChange={handleClientGroupDetailsChange}
            isSearchable={true}
            isLoading={clientGroupIsLoading}
            onMenuClose={() => setClientGroupOffset(0)}
            onMenuScrollToBottom={(e: any) => checkClientGroupBottom(e)}
            onInputChange={(e) => {
              setClientGroupText(e);
            }}
            isDisabled={isDisabled}
          />
        </div>
      </div>
    </>
  );
};

export default AssignedTo;
